import React from "react";
import {CRow} from "@coreui/react";
import classNames from "classnames";
import ItemsPerPageSelector from "../ItemsPerPageSelector";
import ProjectSelector from "../../../components/ProjectSelector";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import {TABLE_ITEMS_PER_PAGE_OPTIONS} from "../../../utils/constants";
import "./IncidentsOverTableRow.scss";

const IncidentsOverTableRow = (props) => {
  const {
    disabled,
    className,
    itemsPerPage,
    projectSelectOptions,
    onItemsPerPageChange,
    onSelectedProjectChange
  } = props;

  return (
    <CRow className={classNames("IncidentsOverTableRow", className)}>
      <ProjectSelector
        options={projectSelectOptions}
        onChange={onSelectedProjectChange}
        disabled={disabled}
      />
      <ItemsPerPageSelector
        options={TABLE_ITEMS_PER_PAGE_OPTIONS}
        onChange={onItemsPerPageChange}
        disabled={disabled}
        value={itemsPerPage}
      />
    </CRow>
  );
};

export default withErrorBoundary(IncidentsOverTableRow);